module.exports = {
          srcSet: __webpack_public_path__ + "5610d7d5d52a73552a68e53429f8e49a-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "5610d7d5d52a73552a68e53429f8e49a-2336.png",width: 2336,height: 468}],
          src: __webpack_public_path__ + "5610d7d5d52a73552a68e53429f8e49a-2336.png",
          toString:function(){return __webpack_public_path__ + "5610d7d5d52a73552a68e53429f8e49a-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AFQxbP1xToX/bkSC/l8qdP9TEWv/WRJm/31Bg/6DVGX+dC5z/3ERhvsAPxRa/U4fZv9SHWr+Vhtt/1kYb/9TAXD/ekRs/pSOgP51SWv/dw6H+1w8KFehB1MoAAAAAElFTkSuQmCC",
          width: 2336,
          height: 468
        }